import React from "react";
import Box from "@mui/material/Box";
import { ZoneManagementTab } from "../../components/aiDetectionSections/ZoneManagementTab.tsx";

/**
 * Administration → Zone Management (Python AI API: cameras + /zones).
 */
export function AdministrationZoneManagement() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        flex: 1,
        minHeight: 0,
        height: "calc(100vh - 220px)",
        maxHeight: "calc(100vh - 220px)",
      }}
    >
      <ZoneManagementTab hideCameraAdminActions />
    </Box>
  );
}
